import {Component, HostBinding} from '@angular/core';

@Component({
	standalone: true,
	selector: 'green-loader',
	template: `<span></span>`,
	styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
	@HostBinding('class') class =
		'absolute inset-0  flex items-center justify-center rounded-2xl';
}
